import { useUpc as useUpcMCL } from '@common-vue/media-card-large';
import { useProductType } from '@composables/useProductType';
import { useConsolidatedLatchkey } from '@modules/latchkey/composables';

/**
 * @param {string} id
 */
export default function useUpc(id) {
  const { isConsolidatedLatchKey } = useProductType();

  if (isConsolidatedLatchKey) {
    return useConsolidatedLatchkey(id).upcData;
  }

  return useUpcMCL(id);
}
